export default __webpack_public_path__ + "static/media/pp3.49b648f9.png";